<template>
    <b-container>
        <h2>Hashtag Sets </h2>
        <p class="mb-5">
            <b-button variant="primary" @click="openHashtagCollector">Create hashtag set</b-button>
        </p>
        <div class="content-area" v-if="!getLoaded"><font-awesome-icon :icon="['fas', 'spinner']" spin /></div>

        <div v-else v-for="set in getHashtagSets" :key="set.id">
            <h5>{{set.name}}</h5>
            <HashtagInput
                    :suggestedHashtags="set.tags"
                    @added="x => update(x, set)"
                    :sets="true"
                    :deleteset="true"
                    :saveset="true"
                    :savesetname=set.name
                    :hashtagsetid="set.id"
                    :compare=true
                    :copy=true />
            <br>
            <b-modal  id="set" size="lg" title="Edit Tagset" hide-footer>
                <app-edit-tagset :index="set" :hashtags="set.tags"/>
            </b-modal>
        </div>
    </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import HashtagInput from "./helpers/HashtagInput";

export default {
    name: 'HashtagSets',
     mounted:function(){
        this.getHashtags()
    },
    components: {
        HashtagInput
    },
    data() {
        return {
            reportUrl: `${process.env.RITETAG_URL}/tagsets-read`,
        }
    },
    methods: {
        ...mapActions('hashtagSets', [
            'setBookmarkHashtag',
            'setCompareSuggestedHashtags',
            'changeSetToBeEdited',
            'setHashtagSets'
        ]),
        ...mapActions('comparison', ['openHashtagCollector']),
        getHashtags () {
            this.setHashtagSets();
            return this.getHashtagSets

        },
        update (hashtag, sets) {
            sets.tags.push(hashtag)
        }
    },
    computed: {
        ...mapGetters('hashtagSets', [
            'getHashtagSets',
            'getLoaded'
        ])
    }

}
</script>

<style scoped>
a {
    text-decoration: none;
    color: black;
}
.bookmarks {
    padding: 0.22rem 0.5rem;
    margin-right: -5px;
    vertical-align: top;
}
.setTags {
    margin: 3px;
}
.col-sm-1{
    display: flex;
}
</style>
